export function expired(expiryDate) {
  return new Date(expiryDate) <= new Date()
}
